import { useContext } from "react";
import { SupportAgentsContext, type SupportAgentsContextType } from "./SupportAgentsContext";

export const useSupportAgents = (): SupportAgentsContextType => {
  const context = useContext(SupportAgentsContext);
  if (!context) {
    throw new Error("useSupportAgents must be used within a SupportAgentsProvider");
  }
  return context;
};
